import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 产品分类 - 是否展示
 */
class ProductCategoryDisplay extends UltMeta {
    /**
     * 不展示
     */
    NO = new Meta(0, "否");
    /**
     * 展示
     */
    YES = new Meta(1, "是");
}

export const PRODUCT_CATEGORY_DISPLAY = new ProductCategoryDisplay();

/**
 * 产品分类 - 状态
 */
class ProductCategoryState extends UltMeta {
    /**
     * 启用
     */
    ENABLED = new Meta(1, "启用");
    /**
     * 禁用
     */
    DISABLED = new Meta(2, "禁用");
}

export const PRODUCT_CATEGORY_STATE = new ProductCategoryState();